import Components from "slotworks/components/components";
import AbstractReelTransition from "slotworks/components/matrix/reel/transition-behaviours/abstract-reel-transition";
import { CascadeTransition } from "slotworks/components/matrix/reel/transition-behaviours/cascade/cascade-transition";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import State from "slotworks/state-machine/states/state";

export default class CascadeSymbols extends State {

    private previousTransition: AbstractReelTransition;

    public onEnter(cascadeSkip?: boolean): void {
        const spinRecord: SpinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        this.previousTransition = Components.matrix.getTransition() as AbstractReelTransition;

        Components.matrix.setTransition(new CascadeTransition());
        Components.matrix.stopTransition(spinRecord, settingsModel.getQuickSpin()).then(() => this.complete());
    }

    public onSkip(cascaded?: boolean): void {
        const spinRecord: SpinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        Components.matrix.getTransition().skip(spinRecord).execute();
    }

    public onExit(): void {
        Components.matrix.setTransition(this.previousTransition);
    }
}
